<template>
    <span>
         <el-tooltip effect="dark" content="批量上传图像" placement="top" :hide-after="1000">
            <el-button size="small" @click="openDialog">
                <i class="nucfont inuc-daorutupian"></i>
            </el-button>
        </el-tooltip>

        <el-dialog title="批量上传图像"
                   width="420px"
                   class="goodMap-import-dialog"
                   :visible.sync="importDialog"
                   :append-to-body="true"
                   :modal-append-to-body="true"
        >
            <div class="explain-text">
                <div class="explain-import">
                    <h3>1、上传流程：</h3>
                    <p>1）将安全的图像放在名为“安全”的文件夹中，将嫌疑的图像放到“嫌疑”的文件夹中</p>
                    <p>2）将两个文件夹一起打包压缩后进行上传，压缩包格式必须为<a class="emphasize"> zip</a></p>
                </div>

                <div class="download">2、点击<a class="sample" :href="zipSampleUrl">下载</a> 压缩包样例文件。</div>
            </div>
            <div slot="footer" class="dialog-footer" style="text-align: center;">
                <label v-if="!importLoading" class="el-button el-button--primary" @change="importMap($event)">
                    开始上传
                     <input type="file" accept=".zip" style="display:none;">
                </label>
                <el-button v-else :loading="importLoading">上传中</el-button>
            </div>
        </el-dialog>
    </span>
</template>

<script>
export default {
    data() {
        return {
            importDialog: false,
            importLoading: false,
            zipSampleUrl: 'https://cloudfront.anjianba.cn/res/漏检图库上传.zip'
        }
    },

    methods: {
        openDialog() {
            this.importDialog = true
        },

        importMap(e) {
            let file = e.target.files[0]
            let formData = new FormData()      //创建form对象
            formData.append('file', file)      //通过append向form对象添加数据

            this.importLoading = true

            let isBackend = this.$route.name === 'mapCollectBG'

            setTimeout(() => {
                this.$api.uploadGraphicZip(formData, isBackend).then(res => {
                    this.importLoading = false

                    this.$notify.success({
                        title: this.$t('m.importSuccess'),
                        message: res.message,
                        duration: 5500
                    })

                    e.target.value = ''

                    this.$emit('importSuccess')

                    this.importDialog = false
                }).catch(error => {
                    console.log(error)
                    this.importLoading = false

                    this.$notify.error({
                        title: this.$t('m.importFail'),
                        message: error.data && error.data.message,
                    })

                    // 出错时清空文件，不然无法触发change
                    e.target.value = ''
                    this.importDialog = false
                })
            }, 500)
        },

    },
}
</script>

<style lang="scss">

.goodMap-import-dialog {
    .explain-text {
        line-height: 1.6;

        .explain-import {
            p {
                color: #666;
                text-indent: 20px;
            }
        }

        .download {
            margin-top: 10px;
            margin-bottom: 10px;
        }

        .emphasize {
            color: #f56c6c;
            font-weight: 600;
        }
        .sample {
            color: #1c42ff;
            text-decoration: underline;
            &:hover {
                color: lighten(#1c42ff, 10%);
            }
        }
    }
}
</style>
